import React, { useCallback, useMemo } from "react";
import { IoHammerOutline } from "react-icons/io5";
import { LiaEditSolid } from "react-icons/lia";

const Beceriler = ({ 
  page, 
  setIsOpen, 
  setModalType, 
  hesabimUserData,
  detayUserData
}) => {
  const userData = page === "hesabim" ? hesabimUserData : detayUserData;
  
  // Skills listesini useMemo ile optimize ediyoruz
  const skills = useMemo(() => {
    const skillsList = userData?.skills || [];
    // İsimlere göre sıralama yapıyoruz
    return [...skillsList].sort((a, b) => a.name.localeCompare(b.name));
  }, [userData?.skills]);

  // Edit ikonuna tıklandığında çalışacak fonksiyonu useCallback ile optimize ediyoruz
  const handleEditClick = useCallback(() => {
    setModalType("Beceriler");
    setIsOpen(true);
  }, [setModalType, setIsOpen]);

  return (
    <div className="detay-container">
      <div
        className={`flex items-center text-dark text-lg tracking-wide font-medium ${
          page === "hesabim" ? "flex-row-reverse justify-between" : "flex gap-3"
        }`}
      >
        <span>
          {page === "hesabim" ? (
            <LiaEditSolid
              className="size-[24px] text-grayy"
              onClick={handleEditClick}
            />
          ) : (
            <IoHammerOutline className="text-dark" />
          )}
        </span>
        <span>Beceriler</span>
      </div>
      <div className="text-grayy text-sm pt-4">
        {!userData ? (
          <p>Yükleniyor...</p>
        ) : skills.length === 0 ? (
          <p>Henüz eklenmiş beceri bulunmuyor.</p>
        ) : (
          <ul className="list-disc ml-4">
            {skills.map((skill, index) => (
              <li key={index} className="my-2">
                {skill.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

// React.memo ile componenti sarmalıyoruz
export default React.memo(Beceriler);
